import getUserLocale from 'get-user-locale';

const sentences = {
    "en_1": " My meetings :",
    "es_1": " Mis encuentros :",
    "fr_1": " Mes reunions :",
    "en_2": "My pinned meetings :",
    "es_2": "Las reuniones marcadas :",
    "fr_2": "Mes réunions épinglées :",
    "en_3": "summary",
    "es_3": "resumen",
    "fr_3": "résumé",
    "en_4": "key points",
    "es_4": "elementos importantes",
    "fr_4": "points clés",
    "en_5": "transcription",
    "es_5": "transcripción",
    "fr_5": "transcription",
    "en_6": "delete this meeting ?",
    "es_6": "¿Quieres borrar esta reunión?",
    "fr_6": "supprimer cette réunion ?",
    "en_7": "Are you sure that you want to remove this meeting ? It will definitivelly erase this meeting from Unpen.",
    "es_7": "¿Seguro que quieres borrar esta reunión? No podrá recuperarse después.",
    "fr_7": "Êtes-vous certain de vouloir supprimer cette réunion? Cela effacera définitivement cette réunion de Unpen.",
    "en_8": "cancel",
    "es_8": "Cancelar",
    "fr_8": "annuler",
    "en_9": "confirm",
    "es_9": "Confirmar",
    "fr_9": "confirmer",
    "en_10": "Open settings",
    "es_10": "Abrir ajustes",
    "fr_10": "ouvrir les paramètres",
    "en_11": "Profile",
    "es_11": "Mi perfil",
    "fr_11": "Profil",
    "en_12": "Logout",
    "es_12": "Desconectar",
    "fr_12": "Deconnexion",
    "en_13": "Credits",
    "es_13": "Creditos",
    "fr_13": "Crédits",
    "en_14": "Login",
    "es_14": "Conectar",
    "fr_14": "Connexion",
    "en_15": "Sign up",
    "es_15": "Registrarse",
    "fr_15": "Inscription",
    "en_16": "Please use a valid email.",
    "es_16": "Verifique que el correo electrónico sea válido.",
    "fr_16": "Veuillez utiliser une addresse mail valide.",
    "en_17": "Passwords do not match.",
    "es_17": "Las contraseñas no coinciden.",
    "fr_17": "Les mots de passe ne correspondent pas.",
    "en_18": "Remember me",
    "es_18": "Recuérdame",
    "fr_18": "Se souvenir de moi",
    "en_19": "Sign in",
    "es_19": "Iniciar sesión",
    "fr_19": "Se connecter",
    "en_20": "Forgot password?",
    "es_20": "¿Recuerda su contraseña?",
    "fr_20": "mot de passe oublié?",
    "en_21": "Don't have an account? Sign Up",
    "es_21": "¿No tiene cuenta? Crear cuenta",
    "fr_21": "Pas encode de compte? Inscrivez-vous",
    "en_22": "password",
    "es_22": "contraseña",
    "fr_22": "mot de passe",
    "en_23": "email Address",
    "es_23": "Correo electrónico",
    "fr_23": "adresse mail",
    "en_24": "Already have an account? Sign In",
    "es_24": "Tiene una cuenta? Inicie sesión",
    "fr_24": "Vous avez déjà un compte? Connectez-vous",
    "en_25": "Key points",
    "es_25": "Puntos clave",
    "fr_25": "Points clés",
    "en_26": "your email has been successfully changed to",
    "es_26": "Se ha cambiado su correo electrónico a",
    "fr_26": "Votre adresse e-mail a bien été remplacée par",
    "en_27": "My email address",
    "es_27": "Mi e-mail",
    "fr_27": "mon adresse mail",
    "en_28": "My password",
    "es_28": "Mi contraseña",
    "fr_28": "Mon mot de passe",
    "en_29": "Modify",
    "es_29": "Modificar",
    "fr_29": "Modifier",
    "en_30": "Please verify that both passwords are the same.",
    "es_30": "Por favor, verifique que ambas contraseñas sean iguales.",
    "fr_30": "Veuillez vérifier que les deux mots de passe sont identiques.",
    "en_31": "Please verify your password.",
    "es_31": "Por favor, verifique su contraseña.",
    "fr_31": "Veuillez vérifier votre mot de passe.",
    "en_32": "Old password",
    "es_32": "Contraseña antigua",
    "fr_32": "ancien mot de passe",
    "en_33": "New password",
    "es_33": "Nueva contraseña",
    "fr_33": "nouveau mot de passe",
    "en_34": "Confirm your new password",
    "es_34": "Confirmar su nueva contraseña",
    "fr_34": "Confirmez votre nouveau mot de passe",
    "en_35": "Confirm",
    "es_35": "Confirmar",
    "fr_35": "Confirmer",
    "en_36": "Update",
    "es_36": "Actualizar",
    "fr_36": "Confirmer",
    "en_37": "Please, select the fields to share :",
    "es_37": "Por favor, seleccione los campos para compartir:",
    "fr_37": "Veuillez sélectionner ce que vous souhaitez partager :",
    "en_38": "Email Address",
    "es_38": "Correo electrónico",
    "fr_38": "Adresse mail",
    "en_39": "send",
    "es_39": "Enviar",
    "fr_39": "envoyer",
    "en_40": "cancel",
    "es_40": "Cancelar",
    "fr_40": "annuler",
    "en_41": "Please, check your microphone.",
    "es_41": "Por favor, verifique su microfono.",
    "fr_41": "S'il vous plaît, vérifiez votre microphone.",
    "en_42": "You can record a new meeting by clicking on the micro icon",
    "es_42": "Usted puede récord una nueva reunión al hacer clic en la icono de micrófono",
    "fr_42": "Vous pouvez enregistrer une nouvelle réunion en cliquant sur l'icône micro",
    "en_43": "in the top bar",
    "es_43": "en la barra superior.",
    "fr_43": "dans la barre qui se trouve en haut",
    "en_44": "at the bottom.",
    "es_44": "que se encuentra abajo.",
    "fr_44": "qui se trouve en bas.",
    "en_45": "The recording will start once you have clicked on the micro icon",
    "es_45": "El registro comenzará una vez que haya hecho clic en el icono de micrófono",
    "fr_45": "L'enregistrement commencera une fois que vous aurez cliqué sur l'icône micro",
    "en_46": "in the bottom bar.",
    "es_46": "en la barra inferior.",
    "fr_46": "dans la barre qui se trouve en bas.",
    "en_47": `You have no more credits.
     Please upgrade your subscription plan or buy more credit.`,
    "es_47": `Usted no tiene más créditos.
     Vea si puede mejorar su plan de suscripción o comprar más créditos.`,
     "fr_47": `Vous n'avez plus de crédits. 
     Veuillez mettre à niveau votre abonnement ou racheter des crédits.`,
    "en_48": "Transcription in progress.",
    "es_48": "Transcripción en curso.",
    "fr_48": "Transcription en cours, veuillez patienter.",
    "en_49": "cancel",
    "es_49": "Cancelar",
    "fr_49": "annuler",
    "en_50": "validate",
    "es_50": "Validar",
    "fr_50": "valider",
    "en_51": "Your meeting has been recorded. You can find it back in the mainpage (",
    "es_51": "Su reunión ha sido grabada. Puede encontrarla en la página principal (",
    "fr_51": "Votre réunion a été enregistrée. Vous pouvez la retrouver sur la page d'accueil (",
    "en_52": "icon) or you can start a new meeting.",
    "es_52": ") o puede comenzar una nueva reunión.",
    "fr_52": ") ou vous pouvez commencer une nouvelle réunion.",
    "en_53": 'Do you wish to replace all instances of "',
    "es_53": '¿Desea reemplazar todas las instancias de ',
    "fr_53": 'Souhaitez-vous remplacer toutes les instances de "',
    "en_54": '" by "',
    "es_54": '" por ',
    "fr_54": '" par "',
    "en_55": "yes",
    "es_55": "Sí",
    "fr_55": "oui",
    "en_56": "no",
    "es_56": "No",
    "fr_56": "non",
    "en_57": "Reset my password",
    "es_57": "Réinitializar mi contraseña.",
    "fr_57": "réinitialiser mon mot de passe",
    "en_58": "A recovery link has been sent to",
    "es_58": "Un enlace de recuperación ha sido enviado a",
    "fr_58": "Un lien de récupération a été envoyé à",
    "en_59": "An error occured.",
    "es_59": "Ocurrió un error.",
    "fr_59": "Une erreur s'est produite.",
    "en_60": "An error occurred, the password hasn't been updated. Please, try again later.",
    "es_60": "Ocurrió un error, la contraseña no ha sido actualizada. Por favor, vuelva a intentarlo más tarde.",
    "fr_60": "Une erreur s'est produite, le mot de passe n'a pas été mis à jour. Veuillez réessayer plus tard.",
    "en_61": "You have consummed all your credits.\nWe continue to record your meeting. However, to access the transcript and summary of the rest of the meeting, you will need to add credits to your account.",
    "es_61": `Usted ha consumido todos sus créditos.
     Para acceder a la transcripción y el resumen del resto de la reunión, deberá agregar créditos a su cuenta.`,
    "fr_61": "Attention : vous n'avez plus de crédits.\nNous continuons à enregistrer votre réunion. Cependant, pour accéder à la transcription et au résumé du reste de la réunion, vous devrez ajouter des crédits à votre compte.",
    "en_62": "Attention: you soon have no more credits.\nto continue transcribing and summarizing your recordings you will need to add credits to your account.",
    "es_62": "Atención: pronto no tendrá más créditos.\nPara continuar transcribiendo y resumiendo sus grabaciones deberá agregar créditos a su cuenta.",
    "fr_62": "Attention : vous n'avez bientôt plus de crédits.\nPour continuer à transcrire et résumer vos enregistrements vous devrez ajouter des crédits à votre compte.",
    "en_63": "Duration of the record",
    "es_63": "Duración del registro",
    "fr_63": "durée de l'enregistrement",
    "en_64": "payment of",
    "es_64": "De pago por",
    "fr_64": "paiement de",
    "en_65": "or",
    "es_65": "o",
    "fr_65": "ou",
    "en_66": " button",
    "es_66": "",
    "fr_66": "",
    "en_67": "Buy credits",
    "es_67": "Comprar créditos",
    "fr_67": "Acheter des crédits",
    "en_68": "Buy credits",
    "es_68": "Comprar créditos",
    "fr_68": "Acheter crédits",
    "en_69": "I have read and agree to the ",
    "es_69": "He leído y acepto los ",
    "fr_69": "J'ai lu et j'accepte les ",
    "en_70": "TOS",
    "es_70": "nueva contraseña",
    "fr_70": "CGU",
    "en_71": " and ",
    "es_71": " y ",
    "fr_71": " et les ",
    "en_72": "terms of sales",
    "es_72": " condiciones de venta",
    "fr_72": "CGV",
    "en_73": "Please accept the terms of sales and TOS",
    "es_73": "Por favor, acepte los nueva contraseña y las condiciones de venta.",
    "fr_73": "Veuillez acceper les CGU et CGV",
    "en_74": "Credits will be consumed according to the length of the audio-file uploaded.",
    "es_74": "Los créditos se consumirán según la longitud del archivo de audio subido.",
    "fr_74": "Vos crédits seront consommés en fonction de la durée du fichier audio envoyé.",
    "en_75": "Key points of your meeting will appears here after five to ten minutes of recording and will be updated as your meeting continues.",
    "es_75": "Los puntos clave de su reunión aparecerán aquí después de cinco a diez minutos de grabación y se actualizarán a medida que continúe la reunión.",
    "fr_75": "Les points clés de votre réunion apparaîtront ici après cinq à dix minutes d'enregistrement et seront mis à jour au fur et à mesure que votre réunion avance.",
    "en_76": "Add ",
    "es_76": "Agregar ",
    "fr_76": "Ajouter ",
    "en_77": "Pay now",
    "es_77": "Pagar",
    "fr_77": "Payer",
    "en_78": "Transform your meetings into productive insights with AI-powered transcription and analysis.",
    "es_78": "Haga que sus reuniones sean más productivas con transcripción y análisis automáticos.",
    "fr_78": "Rendez vos réunions plus productives grâce à la transcription et à l’analyse automatique.",
    "en_79": "Experience intelligent transcription, instant summaries, and seamless collaboration that makes every meeting count.",
    "es_79": "Experimente la transcripción inteligente, los resúmenes instantáneos y la colaboración perfecta que hace que cada reunión cuente.",
    "fr_79": "Expérimentez une transcription intelligente, des résumés instantanés et une collaboration fluide, pour des réunions qui comptent vraiment.",
    "en_80": "Start free trial",
    "es_80": "Prueba gratis",
    "fr_80": "Essayer gratuitement",
    "en_81": "Watch Demo",
    "es_81": "Ver demo",
    "fr_81": "Regarder la démo",
    "en_82": "Key points in real time",
    "es_82": "Puntos clave en tiempo real",
    "fr_82": "Points-clés en temps réel",
    "en_83": "Automatic summaries",
    "es_83": "Resúmenes automáticos",
    "fr_83": "Résumés automatiques",
    "en_84": "Share your summaries by mail",
    "es_84": "Comparte tus resúmenes por correo electrónico",
    "fr_84": "Partagez vos résumés par mail",
    "en_85": "Why Choose Unpen?",
    "es_85": "¿Por qué elegir unpen?",
    "fr_85": "Pourquoi choisir unpen ?",
    "en_86": "Discover the powerful features that make Unpen the preferred choice for modern teams",
    "es_86": "Descubra las características de Unpen que lo convierten en la opción ideal para sus equipos.",
    "fr_86": "Découvrez les fonctionnalités d'Unpen qui en font le choix idéal pour vos équipes.",
    "en_87": "Privacy-Centric",
    "es_87": "Diseñado para la privacidad",
    "fr_87": "Conçu pour la confidentialité",
    "en_88": "Your data is yours. We encrypt it, do not share it with other companies and do not reuse for any purpose.",
    "es_88": "Tus datos son tuyos. Los encriptamos, no los compartimos con otras empresas y no los reutilizamos.",
    "fr_88": "Vos données vous appartiennent. Nous les chiffrons, ne les partageons pas avec d’autres entreprises et ne les réutilisons pas.",
    "en_89": "Effortless Note Taking",
    "es_89": "Toma de notas automático",
    "fr_89": "Prise de notes automatique",
    "en_90": "AI-powered transcription and intelligent summaries eliminate manual note-taking forever.",
    "es_90": "La transcripción automática y los resúmenes generados por IA le permiten centrarse en su reunión en lugar de en sus notas.",
    "fr_90": "La transcription automatique et les résumés générés par IA vous permettent de vous concentrer sur votre réunion plutôt que sur vos notes.",
    "en_91": "Team Collaboration",
    "es_91": "colaboración del equipo",
    "fr_91": "collaboration d'équipe",
    "en_92": "Share meeting insights effortlessly with your team by email, pdf, word or directly inside unpen.",
    "es_92": "Comparta fácilmente sus reuniones con su equipo por correo electrónico, pdf, word o directamente en nuestra plataforma.",
    "fr_92": "Partagez facilement vos réunions avec votre équipe par mail, pdf, word ou directement sur notre plateforme.",
    "en_93": "Users",
    "es_93": "usuarios",
    "fr_93": "Utilisateurs",
    "en_94": "Time Saved",
    "es_94": "ahorro de tiempo",
    "fr_94": "temps économisé",
    "en_95": "Support",
    "es_95": "asistencia",
    "fr_95": "Support",
    "en_96": "What Our Users Say about us",
    "es_96": "Lo que nuestros usuarios dicen de nosotros",
    "fr_96": "Ce que nos utilisateurs disent de nous",
    "en_97": "Everything You Need",
    "es_97": "Todo lo que necesitas",
    "fr_97": "Tout ce que vous devez",
    "en_98": "to know",
    "es_98": "saber",
    "fr_98": "savoir",
    "en_99": "Get answers to common questions about Unpen's AI-powered meeting summary service",
    "es_99": "Respuestas a preguntas frecuentes sobre el servicio de resumen de reuniones Unpen",
    "fr_99": "Réponses aux questions courantes sur le service de résumé de réunions Unpen",
    "en_100": "Ready to Transform Your Meetings?",
    "es_100": "Listo para transformar sus reuniones?",
    "fr_100": "Prêt à transformer vos réunions ?",
    "en_101": "Join tens of teams already using Unpen to make their meetings more productive and insightful.",
    "es_101": "Únete a docenas de equipos que ya usan Unpen para hacer sus reuniones más productivas y eficientes.",
    "fr_101": "Rejoignez des dizaines d’équipes qui utilisent déjà Unpen pour rendre leurs réunions plus productives et efficaces.",
    "en_102": "Transform Your Meetings with",
    "es_102": "Transforme sus reuniones con",
    "fr_102": "Transformez vos réunions avec",
    "en_103": "Easy to use",
    "es_103": "fácil de usar",
    "fr_103": "Simple d'utilisation",
    "en_104": "Privacy-First",
    "es_104": "Respeta su privacidad",
    "fr_104": "Respecte votre confidentialité",
    "en_105": "Secure",
    "es_105": "Seguro",
    "fr_105": "Sécurisé",
    "en_106": "Editable Transcripts and Summaries",
    "es_106": "Transcripciones y resúmenes editables",
    "fr_106": "Transcriptions et résumés éditables",
    "en_107": "Accurate Transcription",
    "es_107": "Transcripción de la reunión",
    "fr_107": "Transcription de la réunion",
    "en_108": "Also work with files recorded offline",
    "es_108": "También funciona con archivos de audio ya grabados",
    "fr_108": "Fonctionne aussi avec des fichiers audios déjà enregistrés",
    "en_109": "No need to use an application",
    "es_109": "No hay necesidad de instalar una aplicación",
    "fr_109": "Pas besoin d'installer une application",
    "en_110": "Secure Data Handling",
    "es_110": "Gestión segura de datos",
    "fr_110": "Gestion sécurisée des données",
    "en_111": "Of satisfied users",
    "es_111": "De usuarios satisfechos",
    "fr_111": "D'utilisateurs satisfaits",
    "en_112": "Product Manager",
    "es_112": "Gerente de producto",
    "fr_112": "Responsable produit",
    "en_113": "Unpen has revolutionized how we handle our team meetings. The summaries are incredibly accurate and save us hours every week.",
    "es_113": "Unpen ha revolucionado la forma en que gestionamos nuestras reuniones de equipo. Los resúmenes son increíblemente precisos y nos ahorran horas cada semana.",
    "fr_113": "Unpen a révolutionné la façon dont nous gérons nos réunions d’équipe. Les résumés sont incroyablement précis et nous font gagner des heures chaque semaine.",
    "en_114": "Salesperson",
    "es_114": "Comercial",
    "fr_114": "Commercial",
    "en_115": "The possibility to record offline and get the summary later on make it a great tool for our team.",
    "es_115": "La capacidad de grabar sin conexión y obtener el resumen más tarde hace que sea una gran herramienta para nuestro equipo.",
    "fr_115": "La possibilité d’enregistrer hors ligne et d’obtenir le résumé plus tard en fait un excellent outil pour notre équipe.",
    "en_116": "HR",
    "es_116": "recursos humanos",
    "fr_116": "RH",
    "en_117": "Lightning-fast transcription make Unpen indispensable for some of our meetings. The privacy-first approach gives us confidence that our sensitive discussions remain secure. Outstanding product!",
    "es_117": "La transcripción ultrarrápida hace que Unpen sea indispensable para algunas de nuestras reuniones. Las medidas de protección de la privacidad nos da confianza que nuestras conversaciones sensibles permanecen seguras.",
    "fr_117": "La transcription ultra-rapide rend Unpen indispensable pour certaines de nos réunions. Les mesures de protection de la vie privée nous donnent confiance que nos discussions sensibles restent sécurisées.",
    "en_118": "Purchase summarization hours once and use them whenever you need. No subscription, no recurring charges - just pay for what you use.",
    "es_118": "Compre horas de resumen una vez y úselas cuando las necesite. Sin suscripción, sin cargos recurrentes - solo pague por lo que use.",
    "fr_118": "Achetez des heures de résumé une fois et utilisez-les quand vous en avez besoin. Pas d'abonnement, pas de frais récurrents - payez uniquement ce que vous utilisez.",
    "en_119": "Work with in-person meetings",
    "es_119": "Funciona con reuniones presenciales",
    "fr_119": "Fonctionne avec les réunions en présentiel",
    "en_120": "summary, meeting, transcription, key points, summarizing meeting, transcribe meeting",
    "es_120": "resumen, reunión, transcripción, puntos clave, resumen de la reunión, transcribir reunión",
    "fr_120": "résumé, réunion, transcription, points clés, résumer une réunion, transcrire une réunion",
    "en_121": "Unpen is your groundbreaking solution for recording, summarizing, and reporting on in-person meetings with unmatched precision and ease. With Unpen, you'll never forget crucial meeting details, decisions, or action items again.",
    "es_121": "Unpen es su solución todo en uno para grabar, resumir y redactar actas de sus reuniones presenciales con una precisión y facilidad inigualables. Con Unpen, no te preocuparás por olvidar nada importante en tus reuniones. La información queda registrada para siempre.",
    "fr_121": "Unpen est votre solution tout en un pour l'enregistrement, le résumé et la rédaction de compte rendu pour vos réunions en présentiel avec une précision et une facilité inégalées.",
    "en_122": "If you have the audio file of an already recorded meeting, you can summarize it using the ",
    "es_122": "Si tiene el archivo de audio de una reunión ya grabada, puede resumirla utilizando el botón ",
    "fr_122": "Si vous avez le fichier audio d'une réunion déjà enregistrée, vous pouvez l'envoyer à l'aide du bouton ",
    "en_123": "Upload audiofile",
    "es_123": "cargador de audio",
    "fr_123": "Charger un fichier audio",
    "en_124": "My meetings",
    "es_124": "Mi reunión",
    "fr_124": "Mes réunions",
    "en_125": "Record meeting",
    "es_125": "Grabar una reunión",
    "fr_125": "Enregistrer une réunion",
    "en_126": "Loading...",
    "es_126": "Cargando...",
    "fr_126": "Chargement...",
    "en_127": "Loading your meetings...",
    "es_127": "Cargando sus reuniones...",
    "fr_127": "Chargement de vos réunions...",
    "en_128": "Select a meeting",
    "es_128": "Seleccionar una reunión",
    "fr_128": "Sélectionner une réunion",
    "en_129": "Choose a meeting from the list to view its details, summary, and transcription.",
    "es_129": "Elija una reunión de la lista para ver sus detalles, resumen y transcripción.",
    "fr_129": "Choisissez une réunion dans la liste pour voir ses détails, résumé et transcription.",
    "en_130": "Email cannot be empty.",
    "es_130": "Su dirección de correo electrónico está vacía.",
    "fr_130": "Votre adresse mail est vide.",
    "en_131": "Password cannot be empty.",
    "es_131": "Su contraseña está vacía.",
    "fr_131": "Votre mot de passe est vide.",
    "en_132": "Your password or your email is wrong.",
    "es_132": "Su contraseña o correo electrónico tiene un error de tecleo.",
    "fr_132": "Votre mot de passe ou votre email contient une erreur de frappe.",
    "en_133": "Please, check your email.",
    "es_133": "Por favor, compruebe su correo electrónico.",
    "fr_133": "S’il vous plaît, vérifiez votre email.",
    "en_134": "Please, check that both passwords are the same.",
    "es_134": "Compruebe que las dos contraseñas sean iguales.",
    "fr_134": "Veuillez vérifier que les deux mots de passe sont les mêmes.",
    "en_135": "Please, accept the TOS to continue.",
    "es_135": "Por favor, acepte las nuevas contraseña para continuar.",
    "fr_135": "S’il vous plaît, acceptez les CGU pour continuer.",
    "en_136": "See how AI transforms your meetings.",
    "es_136": "",
    "fr_136": "",
    "en_137": "Normal",
    "es_137": "Normal",
    "fr_137": "Normal",
    "en_138": "Large Heading",
    "es_138": "Titulo 1",
    "fr_138": "Titre principal",
    "en_139": "Small Heading",
    "es_139": "Titulo 2",
    "fr_139": "Titre secondaire",
    "en_140": "Bullet List",
    "es_140": "lista con viñetas",
    "fr_140": "Liste à puces",
    "en_141": "Numbered List",
    "es_141": "lista numeradas",
    "fr_141": "Liste numérotée",
    "en_142": "Quote",
    "es_142": "Cita",
    "fr_142": "Citation",
    "en_143": "Cancel Upload",
    "es_143": "Cancelar la descarga",
    "fr_143": "Annuler le téléchargement",
    "en_144": "Are you sure you want to cancel the current upload? This action cannot be undone.",
    "es_144": "¿Está seguro de que quiere cancelar la descarga actual? Esta acción no se puede deshacer.",
    "fr_144": "Êtes-vous sûr de vouloir annuler le téléchargement actuel ? Cette action ne peut pas être annulée.",
    "en_145": "Yes, Cancel Upload",
    "es_145": "Sí, cancelar la descarga",
    "fr_145": "Oui, annuler le téléchargement",
    "en_146": "Continue Upload",
    "es_146": "continuar la descarga",
    "fr_146": "Continuer le téléchargement",
    "en_147": "Are you sure you want to proceed?",
    "es_147": "¿Está seguro de que quiere continuar?",
    "fr_147": "Êtes-vous sûr de vouloir continuer ?",
    "en_148": "Confirm Action",
    "es_148": "Confirmación",
    "fr_148": "Confirmation",
    "en_149": "Date Created",
    "es_149": "fecha",
    "fr_149": "Date",
    "en_150": "Title",
    "es_150": "Titular",
    "fr_150": "Titre",
    "en_151": "Duration",
    "es_151": "Duración",
    "fr_151": "Durée",
    "en_152": "Longest first",
    "es_152": "De la mayor duración a la más corta",
    "fr_152": "Du plus long au plus court",
    "en_153": "Shortest first",
    "es_153": "De menor a mayor duración",
    "fr_153": "Du plus court au plus long",
    "en_154": "Newest first",
    "es_154": "Más recientes primero",
    "fr_154": "Plus récentes en premier",
    "en_155": "Oldest first",
    "es_155": "Más antiguas primero",
    "fr_155": "Plus anciennes en premier",
    "en_156": "Z to A (descending)",
    "es_156": "Z a A (descendente)",
    "fr_156": "Z à A (décroissant)",
    "en_157": "A to Z (ascending)",
    "es_157": "A a Z (ascendente)",
    "fr_157": "A à Z (croissant)",
    "en_158": "Search meetings...",
    "es_158": "Buscar una reunión...",
    "fr_158": "Rechercher une réunion...",
    "en_159": "Enhanced content will appear here...",
    "es_159": "El nuevo contenido aparecerá aquí...",
    "fr_159": "Le nouveau contenu apparaîtra ici...",
    "en_160": "Download Meeting Content",
    "es_160": "Descargar la reunión",
    "fr_160": "Télécharger la réunion",
    "en_161": "Download",
    "es_161": "Descargar",
    "fr_161": "Télécharger",
    "en_162": "Downloading...",
    "es_162": "descarga...",
    "fr_162": "Téléchargement...",
    "en_163": "Audio",
    "es_163": "Audio",
    "fr_163": "Audio",
    "en_164": "Original text",
    "es_164": "Texto original",
    "fr_164": "Texte d'origine",
    "en_165": "Detailed text (Editable)",
    "es_165": "Nuevo texto (editable)",
    "fr_165": "Nouveau texte (éditable)",
    "en_166": "",//"Credit Consumption Notice",
    "es_166": "",//"Consumo de créditos",
    "fr_166": "",//"Consommation de crédits",
    "en_167": "This action will add details to your content. You will be able to edit the enhanced content before applying it.",
    "es_167": "Esta acción agregar detalles a su contenido. Podrás editar el contenido mejorado antes de aplicarlo.",
    "fr_167": "Cette action ajoutera des détails à votre contenu. Vous pourrez modifier le contenu amélioré avant de l’appliquer.",
    "en_168": "Content to be detailed",
    "es_168": "Contenido a detallar",
    "fr_168": "Contenu à détailler",
    "en_169": "Enhancing content...",
    "es_169": "Reescritura en curso",
    "fr_169": "Réécriture en cours",
    "en_170": "Sort by:",
    "es_170": "Ordenar por:",
    "fr_170": "Trier par :",
    "en_171": "Processing...",
    "es_171": "Redacción del nuevo texto...",
    "fr_171": "Rédaction du nouveau texte...",
    "en_172": "Proceed",
    "es_172": "Continuar",
    "fr_172": "Continuer",
    "en_173": "Replace Content",
    "es_173": "Sustituyera el texto",
    "fr_173": "Remplacer le texte",
    "en_174": "characters",
    "es_174": "caracteres",
    "fr_174": "caractères",
    "en_175": "Develops section",
    "es_175": "Expandir la sección",
    "fr_175": "Développer cette section",
    "en_176": "Edit developed content",
    "es_176": "Editar el nuevo texto",
    "fr_176": "Éditer le nouveau texte",
    "en_177": "📋 Copy Cell",
    "es_177": "📋 Copiar la celda",
    "fr_177": "📋 Copier la cellule",
    "en_178": "📄 Paste Cell",
    "es_178": "📄 Pegar la celda",
    "fr_178": "📄 Coller la cellule",
    "en_179": "🗑️ Clear Cell",
    "es_179": "🗑️ Eliminar la celda",
    "fr_179": "🗑️ Supprimer la cellule",
    "en_180": "➕ Add Row Above",
    "es_180": "➕ Añadir una línea por encima",
    "fr_180": "➕ Ajouter une ligne au-dessus",
    "en_181": "➕ Add Row Below",
    "es_181": "➕ Añadir una línea debajo",
    "fr_181": "➕ Ajouter une ligne en-dessous",
    "en_182": "➕ Add Column Left",
    "es_182": "➕ Añadir una columna a la izquierda",
    "fr_182": "➕ Ajouter une colonne à gauche",
    "en_183": "➕ Add Column Right",
    "es_183": "➕ Añadir una columna a la derecha",
    "fr_183": "➕ Ajouter une colonne à droite",
    "en_184": "❌ Delete Row",
    "es_184": "❌ Eliminar la línea",
    "fr_184": "❌ Supprimer la ligne",
    "en_185": "❌ Delete Column",
    "es_185": "❌ Eliminar la columna",
    "fr_185": "❌ Supprimer la colonne",
    "en_186": "Watch Unpen in Action",
    "es_186": "",
    "fr_186": "",
    "en_187": "Demo",
    "es_187": "Demo",
    "fr_187": "Démo",
    "en_188": "Pay monthly",
    "es_188": "Pago mensual",
    "fr_188": "Abonnement mensuel",
    "en_189": "Pay yearly",
    "es_189": "Pago anual",
    "fr_189": "Abonnement annuel",
    "en_190": "Credits",
    "es_190": "Compra de horas",
    "fr_190": "Achat de crédits",
    "en_191": "Monthly subscription, without commitment.",
    "es_191": "Suscripción mensual sin compromiso.",
    "fr_191": "Abonnement mensuel, sans engagement.",
    "en_192": "Annual subscription, pay in one go and save a full month worth.",
    "es_192": "Suscripción anual, pague una sola vez y ahorre un mes de suscripción.",
    "fr_192": "Abonnement annuel, payez en une fois et économisez un mois d'abonnement.",
    "en_193": "No subscription, no recurring charges - pay only for what you use.",
    "es_193": "Sin suscripción, sin cargos recurrentes - pague solo lo que use.",
    "fr_193": "Pas d'abonnement, pas de frais récurrents - payez uniquement ce que vous utilisez.",
    "en_194": "Contact us at contact@unpen.eu for custom rates. An installation of our solution on your servers (\"on premise \") is also possible.",
    "es_194": "Contáctenos en contact@unpen.eu para tarifas personalizadas. También es posible instalar nuestra solución en sus servidores.",
    "fr_194": "Contactez-nous à contact@unpen.eu pour des tarifs sur mesure. Une installation de notre solution sur vos serveurs (\"on premise\") est également possible.",
    "en_195": "Buy",
    "es_195": "Comprar",
    "fr_195": "Acheter",
    "en_196": "month",
    "es_196": "mes",
    "fr_196": "mois",

}


export function getSentence(sentenceId)
{
    //sentenceId : int
    //Return the sentence sentenceId in the user's language.
    var languageCode = getLanguage()
    return sentences[languageCode + "_" + sentenceId]
}


export function getUppyLocal()
{
    //Translations for the file uploader uppy
    //uppy doc on the subject : https://uppy.io/docs/dashboard/#locale

    var languageCode = getLanguage()
    languageCode = languageCode.substring(0,2)

    if (languageCode == "fr")
    {
        return {strings:{dropPasteFiles: 'Déposer votre fichier audio à résumer ici ou %{browseFiles}',
        importFiles: 'Importer des fichiers de:',
        browseFiles: 'parcourir les fichiers',
        dropHint: 'Déposez votre fichier ici',
        uploadComplete: 'Envoie terminé',
            // Used as the hover text and screen reader label for file progress indicators when they have been fully uploaded.
        uploadPaused: 'Envoie en pause',
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Continuer l'envoie",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: 'Mettre en pause',
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: 'Réessayer',
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Annuler l'envoie",
        uploadingXFiles: {
			0: 'Envoie de %{smart_count} fichier',
			1: 'envoie de %{smart_count} fichier',
        },
        // Used for the buttons to cancel uploads.
		cancel: 'Annuler',
      }}
    }

    else if (languageCode == "es")
    {
        return {strings:{dropPasteFiles: 'Coloque su archivo de audio para resumir aquí o %{browseFiles}',
        importFiles: 'Importar archivos de:',
        browseFiles: 'navegar por los archivos',
        dropHint: 'Suelte su archivo aquí',
        uploadComplete: 'Envío completado',
            // Used as the hover text and screen reader label for file progress indicators when they have been fully uploaded.
        uploadPaused: 'Envía en pausa',
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Continuar el envío",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: 'Pausar',
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: 'Intentar de nuevo',
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Cancelar el envío",
        uploadingXFiles: {
			0: 'Envío de %{smart_count} archivos',
			1: 'Envío de %{smart_count} archivos',
        },
        // Used for the buttons to cancel uploads.
		cancel: 'Cancelar',
      }}
    }

    else
    {
        return {strings:{dropPasteFiles: 'Drop your audiofile to summarize here or %{browseFiles}',
        importFiles: 'Import files from:',
        browseFiles: 'browse files',
        dropHint: 'Drop your file here',
        uploadComplete: 'Upload complete',
            // Used as the hover text and screen reader label for file progress indicators when they have been fully uploaded.
        uploadPaused: 'Upload paused',
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: 'Resume upload',
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: 'Pause upload',
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: 'Retry upload',
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: 'Cancel upload',
        uploadingXFiles: {
			0: 'Uploading %{smart_count} file',
			1: 'Uploading %{smart_count} files',
		},
        // Used for the buttons to cancel uploads.
		cancel: 'Cancel',
      }}
    }
}


export function getLanguage()
{
    //Return the user language as a 2 letter code.
    //If a language is specified in the url it is choosen, otherwise the navigator lang is used.
    //If the language isn't in existingLanguageCode then "en" is returned.

    const existingLanguageCode = ["en", "es", "fr"]

    if (window.location.pathname.includes("/en/") || window.location.pathname.split("/").pop() == "en"){
		return "en"
	}
	else if (window.location.pathname.includes("/es/") || window.location.pathname.split("/").pop() == "es"){
        return "es"
	}
	else if (window.location.pathname.includes("/fr/") || window.location.pathname.split("/").pop() == "fr"){
        return "fr"
	}

    var languageCode = getUserLocale()
    languageCode = languageCode.substring(0,2)
    if (!existingLanguageCode.includes(languageCode)){
        languageCode = "en"
    }

    return languageCode
}
